import React, { useState, useEffect, useCallback, useRef } from "react";
import MessageIcon from "@mui/icons-material/Message";
import Box from "@mui/material/Box";
// import CardMedia from "@mui/material/CardMedia";
import { Button, Card, Divider, p } from "@mui/material";
// import TextField from "@mui/material/TextField";
import { keyframes } from "@mui/system";
import { styled } from "@mui/material/styles";
import NoImage from "../../images/resources/noImage.jpg";
import theme from "./theme";
import { auctionsLive } from "../../Model/Auction";
import "./Center.css";

import useMediaQuery from "@mui/material/useMediaQuery";
import { getUser } from "../../Model/LocalStorage";

// import CardContent from "@mui/material/CardContent";
// import CardMedia from "@mui/material/CardMedia";
// import IconButton from "@mui/material/IconButton";
// import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
// import VideocamIcon from '@mui/icons-material/Videocam';
// import SkipNextIcon from "@mui/icons-material/SkipNext";
// import { WebRTCPlayer } from "@eyevinn/webrtc-player";

const blink = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const BlinkedBox = styled("div")({
  color: "red",
  animation: `${blink} 1s linear infinite`,
});

// document.addEventListener("visibilitychange", () => {
//   if (document.visibilityState === "visible") {
//     // Reinitialize or reload the Wowza WebRTC player
//     // console.log("Tab is active again. Reconnecting the player...");
//     reconnectPlayer();
//   }
// });

// async function reconnectPlayer() {

//   try {
//     const videos = document.querySelector("video");
//   const player = new WebRTCPlayer({
//     video: videos,
//     // timeoutThreshold: 3000,
//     type: "whep",

//   });

//   // console.log("player ",player)

//   await player.load(
//     new URL(
//       "https://customer-gc73aqvl9oq83lia.cloudflarestream.com/359346f60f669e61d8b1efb7353292da/webRTC/play"
//     )
//   );
//   player.unmute();

//   player.on("no-media", () => {
//     console.log("media timeout occured");
//   });
//   player.on("media-recovered", () => {
//     console.log("media recovered");
//   });

//   // Subscribe for RTC stats: `stats:${RTCStatsType}`
//   player.on("stats:inbound-rtp", (report) => {
//     if (report.kind === "video") {
//      // console.log("report");

//     }

//   });
//   } catch (error) {

//   }

// }

const  Midlayout = ({
  details,
  socket,
  mediadQuery,
  titleAuction,
}) => {
  const classes = theme();
  const videoRef = (useRef < HTMLVideoElement) | (null > null);
  const [sold, setSold] = useState("");
  const [getData, setGetData] = useState([]);
  const [image, setImage] = useState([]);
  const [status, setStatus] = useState("");
  const [announcement, setAnnouncement] = useState("");
  const [switchMode, setSwitch] = useState(true);
  const matchesPhone = useMediaQuery("(min-width:700px)");
  const [more, setMore] = useState(false);
  const [lotnumber, setLotNumber] = useState(null);
  const [username, setUsername] = useState("");

  const handleMore = () => {
    setMore(!more);
  };
  const ListData = useCallback((val) => {

    async function getAuctionOne() {
      const results = await auctionsLive();

      if (results.success === true) {
        setSold("");
        // console.log("results ",results)
        setGetData(results.lot.details);
        setLotNumber(results.lot.details[0].lot_number);
        setImage(results.lot.image_lot);
      } else {
      }
    }
    getAuctionOne().catch(console.error);
  },[])


  const [userID, setUserID] = useState("");
    



  useEffect(() => {
    // reconnectPlayer();
    async function getUserList() {
      const getuser = await getUser();
      setUserID(getuser.id);
      setUsername(getuser.email);
      socket.emit("ConnectedUser", {
        userId: getuser.id,
        email: getuser.email,
      });
    }
    getUserList().catch(console.error);
    try {

      console.log("emage " ,details.lot.image_lot);
      console.log("lot number ",details.lot.details[0].lot_number)

      setStatus(details.lot.details[0].lot_status);

      if (details.lot.details[0].lot_status === "SOLD") {
        setSold(
          <div className="overlay11" style={{ color: "#59bb59" }}>
            <div className="statusCss">SOLD</div>
          </div>
        );
      } else if (details.lot.details[0].lot_status === "UNSOLD") {
        setSold(
          <div className="overlay11" style={{ color: "#ff4949" }}>
            <div className="statusUnsold">UNSOLD</div>
          </div>
        );
      } else if (details.lot.details[0].lot_status === "PASS") {
        setSold(
          <div className="overlay11" style={{ color: "#0bf8bf" }}>
            PASS
          </div>
        );
      } else if (details.lot.details[0].lot_status === "RESERVE_NOT_MET") {
        setSold(
          <div className="overlay11" style={{ color: "#fffd00" }}>
            <div
              className="statusUnsold"
              style={{ lineHeight: "normal", fontSize: 45 }}
            >
              RESERVE NOT MET
            </div>
          </div>
        );
      } else {
        setSold("");
      }
      setImage(details.lot.image_lot);
      setAnnouncement(details.announcement[0].announcement);
      setGetData(details.lot.details);
      setLotNumber(details.lot.details[0].lot_number);
    } catch (error) {
      // setImage("");
      setGetData([]);
    }

    socket.on("receiveMessage", (data) => {
      // alert("receive_status 2")
      setAnnouncement(data.message);
    });

    socket.on("receive_status", (data) => {
      // alert(data.message)
      if (data.message === "SOLD") {
        setSold(
          <div className="overlay11" style={{ color: "#59bb59" }}>
            <div className="statusCss">SOLD</div>
          </div>
        );
      } else if (data.message === "UNSOLD") {
        setSold(
          <div className="overlay11" style={{ color: "#ff4949" }}>
            <div className="statusUnsold">UNSOLD</div>
          </div>
        );
        // } else if (data.message === "PASS") {
        //   setSold(
        //     <div className="overlay11" style={{ color: "#0bf8bf" }}>
        //         <div className="statusUnsold">PASS</div>
        //     </div>
        //   );
      } else if (data.message === "RESERVE_NOT_MET") {
        setSold(
          <div className="overlay11" style={{ color: "#fffd00" }}>
            <div
              className="statusUnsold"
              style={{ lineHeight: "normal", fontSize: 45 }}
            >
              RESERVE NOT MET
            </div>
          </div>
        );
      } else if (data.message === "NEXTSLOT" || data.message === "PASS") {
        setTimeout(() => {
          // setImage([])
          return ListData();
        }, 1000);
      } else {
        setSold("");
      }

      setStatus(data.message);
    });

    // return () => socket.removeAllListeners()

  }, [details, socket]);

  const handleSwitch = () => {
    setSwitch(!switchMode);
  };


  const [open, setOpen] = React.useState(true);


  const handleClose = () => {
    setOpen(!open);
  };


  return (
    <>
    <div style={{float:'right',padding:5,height: "100lvh"}}>

      <p  style={{background: 'red',color: 'white',padding:2,textAlign: 'center',borderRadius:20,width:70,display: mediadQuery === false ? "none" : "block",}}>Live</p>


    </div>
           
    {status === "OPEN" ? (
              ""
            ) : (
              <BlinkedBox
                style={{
                  
                  fontSize: 18,
                  display: status !== "" ? "block" : "none",
                  display:
                    status === "FAIR_WARNING" || status === "OPEN"
                      ? "block"
                      : "none",
                }}
              >
                <div className="boxStatusOne" style={{ position: "static", }}>
                  <div
                    className="boxStatus"
                    style={{
                      backgroundColor:
                        status === "FAIR_WARNING" ? "red" : "green",
                      color: "white",
                    }}
                  >
                    <p style={{ margin: "auto",fontWeight: 'bold' }}>{status}</p>
                  </div>
                </div>
              </BlinkedBox>
            )}
      {mediadQuery === false ? (
        <div style={{marginTop:10,}}>


        <p
          gutterBottom
          style={{ fontWeight: "bold", textAlign: "center" }}
        >
          {titleAuction}
        </p>
        </div>
      ) : (
        ""
      )}

      <div >
        <div
          className=""
          style={{
            marginTop:10,
            maxWidth: mediadQuery === false ? "" : "100%",
            margin: mediadQuery === false ? "" : "auto",
          }}
        >
          <div
            className="container11"
            style={{

              width:
                mediadQuery === false
                  ? image.slice(1).length
                    ? "65%"
                    : switchMode === true
                    ? "80%"
                    : "100%"
                  : "65%",
                 margin: mediadQuery === false ? "auto" : "",
              // border: "1px solid #ccc",
            }}
          >

            {mediadQuery === false ? (
              <div style={{   marginBottom: mediadQuery === false ? 20 : 0,border: "1px solid rgb(204, 204, 204)",}}>
                 <div style={{
                        // display: switchMode === true ? "inline-block" : "none", 
                         backgroundImage: `url(${image.length ? image[0].img_url : NoImage})`,
                        backgroundColor: "#ffffff",
                        width: "100%",
                        height:  "100vh",
                        // display: "inline-block",
                        backgroundSize: "contain",
                        backgroundPosition: "center center",
                        backgroundRepeat: "no-repeat",
                        padding: 10,
                         }} >
                 </div>

              </div>
            ) : (
              <div style={{
                // display: switchMode === true ? "inline-block" : "none", 
                 backgroundImage: `url(${image.length ? image[0].img_url : NoImage})`,
                backgroundColor: "#ffffff",
                width: "100%",
                height:  "100vh",
                // display: "inline-block",
                backgroundSize: "contain",
                backgroundPosition: "center center",
                backgroundRepeat: "no-repeat",
                padding: 10,
                 }} >
         </div>

            )}

            {switchMode === false ? "" : sold}
            {/* <div class="overlay_sold">Sold</div> */}
          </div>
       
          
        </div>
      </div>

  

    </>
  );
}

export default Midlayout;

//"https://leongallery.sgp1.digitaloceanspaces.com/v2/private-sale/PRIVATE_SALE/69.jpg" "https://wallpapers.com/images/featured/hd-a5u9zq0a0ymy2dug.jpg"
